import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {appTitle_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/appTitle_template";
import {brandSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/brandSelector_template";
import {userSection_template} from "./userSection_template";
//import {sampleSection_template} from "./sampleSection_template";
import {menu_collapsible_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/menu_collapsible_template";

declare var ko: any;
export class menuNav_template extends vnTemplate{

    protected appTitle: appTitle_template;
    protected brandSelector: brandSelector_template;
    protected userSection: userSection_template;
    protected menuTemplate: menu_collapsible_template;
    //protected sampleSection : sampleSection_template

    protected getTemplateHtml(): string{


        return  this.appTitle.getHtmlBuild() +
            this.userSection.getHtmlBuild() +
            this.brandSelector.getHtmlBuild() +
            this.menuTemplate.getHtmlBuild();
    }

    protected initPartial(): void {

        this.appTitle = new appTitle_template("appTitle", this.getTemplateViewModel(), this.caller);
        this.appTitle.setTitle("emakicms");

        this.brandSelector = new brandSelector_template("brandSelector", this.getTemplateViewModel(), this.caller);
        this.brandSelector.setSelected({id: 0, name: "-select property-"});

        this.userSection = new userSection_template("userHeader", this.getTemplateViewModel(), this.caller);

        this.menuTemplate = new menu_collapsible_template("mainNavMenu", this.getTemplateViewModel(), this.caller);

        //this.sampleSection = new sampleSection_template("sampleSection", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{
        return "menuNav-template";
    }
    protected getMainElementType(): string{
        return "nav";
    }
    protected getMainElementClasses(): Array<string>{
        return ["main-nav"];
    }

    protected buildViewModel(): any{

        return  {
            user: ko.observable(null),
            menuItems: ko.observableArray([])

        };
    }

    public disableUserLink(){

        this.userSection.setIsUserLinkDisabled(true);
    }

    public disableEmakiLink(){

        this.appTitle.setIsLinkDisabled(true);
    }


    public changeSelection(idSelected){

        this.caller.changeSelection(idSelected);
    }

    /*
    menuClick(data, event){
        for( let m of this.viewModel[this.idElement].menus()){
            m.selected(false);
        }
        data.selected(true);
        return true;
    }
    */
    setMenus(menus: Array<{id:number,text:string,url:string, subMenus: Array<{text:string,url:string}>, cssClass: Array<string>}>): void{
        this.menuTemplate.setMenus(menus);
    }

    //
    // set the user display
    setUser(user: any){
        this.userSection.setUser(user);
        //this.sampleSection.setUser(user);
    }

    //
    // set and select the brand drop down menu
    setBrands(brands: any){
        this.brandSelector.setItems(brands);
        this.userSection.setBrands(brands)
    }
    setSelectedBrand(idBrand: number){
        window.sessionStorage.setItem('currentBrandId', String(idBrand));

        this.brandSelector.setSelectedById(idBrand);
    }

    getSelectedBrand(): number {
        return this.brandSelector.getTemplateViewModel().selected();
    }

    public setMenuItems(menuItems: Array<Object>): void {
        this.getTemplateViewModel().menuItems(menuItems);
    }

    public setDefaultSectionId(sectionId): void {
        window.localStorage.setItem('defaultBrandMenuSection', sectionId);
    }
    public getDefaultSectionId() {
        return window.localStorage.getItem('defaultBrandMenuSection');
    }

    public getMenus() {
        return this.menuTemplate.getMenus();
    }

    public handleComponentVisibility(): void {

        let brandSelector = document.getElementById('brandSelector');
        let mainNavListBtn = brandSelector.querySelector("button");
        let mainNavList = brandSelector.querySelector(".main-nav-list");

        mainNavListBtn.addEventListener('click', (event) => {

            let selectedNavElements = document.getElementById('mainNavMenu').querySelectorAll(".is-selected");

            if (selectedNavElements.length > 0) {

                mainNavList.classList.remove('is-hidden');
            }

            for (let i = 0; i < selectedNavElements.length; i++) {

                selectedNavElements[i].classList.remove('is-selected');
            }
        });

        let selectedNavElements = document.getElementById('mainNavMenu').querySelectorAll(".main-nav-item");
        for (let i = 0; i < selectedNavElements.length; i++) {

            selectedNavElements[i].addEventListener('click', (event) => {

                for (let i = 0; i < selectedNavElements.length; i++) {

                    selectedNavElements[i].classList.remove('is-selected');
                }

                if (event.target instanceof Element) {

                    let mainNavList = document.getElementsByClassName('main-nav-list')[0];
                    event.target.classList.add('is-selected');
                    mainNavList.classList.add('is-hidden');
                }
            });
        }

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/menuNav_template.ts